import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-502a2fe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-with-text" }

import { inject, reactive } from 'vue'
  import type { UploadRawFile, UploadRequestOptions } from 'element-plus'
  import { ElNotification as notify, useGetDerivedNamespace } from 'element-plus'
  import { useRoute, useRouter } from 'vue-router'
  import axios from 'axios';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

  const router = useRouter();
  const $axios : any = inject('axios');

  const fileList: UploadRawFile[] = [];
  
  // do not use same name with ref
  const form = reactive({
    username: '',
    password: ''
  });
  
  const onSubmit = () => {
    $axios.post(`/login?username=${form.username}&password=${form.password}`).then((res: any) => {
      if (res.data.code === 200) {
        window.location.reload();
      }
      else {
        notify('Incorrect Credentials')
      }
    });
    // window.location.href = "https://www.google.com";
  }

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", _hoisted_1, [
      _createVNode(_component_el_divider, {
        class: "divider",
        "border-style": "double"
      }),
      _createTextVNode(" Login Form "),
      _createVNode(_component_el_divider, {
        class: "divider",
        "border-style": "double"
      })
    ]),
    _createVNode(_component_el_form, {
      "label-position": "left",
      model: form,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Username" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
              placeholder: "Please input username"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Password" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
              type: "password",
              placeholder: "Please input password",
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              color: "#232946",
              onClick: onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})